import React from "react";
import { Typography } from "@mui/material";
import RenewSubscriptionScreen from "../components/RenewSubscriptionScreen";

const PaymentPending = () => {
	return <RenewSubscriptionScreen title={"Merci ! Votre commande est en cours de validation."} />;
};

export default PaymentPending;
